import { render, staticRenderFns } from "./NonClickableImg.vue?vue&type=template&id=7cd477b0&"
import script from "./NonClickableImg.vue?vue&type=script&lang=js&"
export * from "./NonClickableImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports